import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { shallow } from 'zustand/shallow';

import { currentOS, OS } from '../../lib/platform';
import { useHomeyPath } from '../../RouteManager';

import { useEventCallback } from '../../hooks/useEventCallback';

import { CommandPaletteDialog } from './CommandPaletteDialog';
import { useCommandPalette } from './CommandPaletteStore';

const selectPaletteState = (state) => {
  return {
    isOpen: state.isOpen,
    open: state.open,
    close: state.close,
  };
};

export function CommandPaletteController() {
  const homeyPath = useHomeyPath();

  const isEnabled = homeyPath != null && homeyPath !== '';

  const { close } = useCommandPalette(selectPaletteState, shallow);

  useEffect(() => {
    if (isEnabled !== true) {
      close();
    }
  }, [close, isEnabled]);

  if (isEnabled !== true) {
    return null;
  }

  return <CommandPaletteControllerEnabled />;
}

function CommandPaletteControllerEnabled() {
  const location = useLocation();

  const { isOpen, open, close } = useCommandPalette(selectPaletteState, shallow);

  useEffect(() => {
    close();
  }, [close, location.pathname, location.search]);

  const onKeyDown = useEventCallback((event) => {
    if (event.repeat === true) {
      return;
    }

    if (event.target instanceof Element) {
      const editableElement = event.target.closest(
        'input, textarea, [contenteditable], [contenteditable="true"], [contenteditable="plaintext-only"]',
      );

      if (editableElement != null) {
        return;
      }
    }

    if (event.key.toLowerCase() !== 'k') {
      return;
    }

    const isModifierPressed = currentOS === OS.MACOS ? event.metaKey : event.ctrlKey;

    if (isModifierPressed !== true || event.altKey === true || event.shiftKey === true) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (isOpen === true) {
      return;
    }

    open();
  });

  useEffect(() => {
    document.documentElement.addEventListener('keydown', onKeyDown);

    return function cleanup() {
      document.documentElement.removeEventListener('keydown', onKeyDown);
    };
  }, [onKeyDown]);

  if (isOpen !== true) {
    return null;
  }

  return <CommandPaletteDialog />;
}
